var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9999 4.70039L1.5499 7.15039C1.45824 7.24206 1.34157 7.28789 1.1999 7.28789C1.05824 7.28789 0.941569 7.24206 0.849902 7.15039C0.758236 7.05872 0.712402 6.94206 0.712402 6.80039C0.712402 6.65872 0.758236 6.54206 0.849902 6.45039L3.2999 4.00039L0.849902 1.55039C0.758236 1.45872 0.712402 1.34206 0.712402 1.20039C0.712402 1.05872 0.758236 0.942057 0.849902 0.850391C0.941569 0.758724 1.05824 0.712891 1.1999 0.712891C1.34157 0.712891 1.45824 0.758724 1.5499 0.850391L3.9999 3.30039L6.4499 0.850391C6.54157 0.758724 6.65824 0.712891 6.7999 0.712891C6.94157 0.712891 7.05824 0.758724 7.1499 0.850391C7.24157 0.942057 7.2874 1.05872 7.2874 1.20039C7.2874 1.34206 7.24157 1.45872 7.1499 1.55039L4.6999 4.00039L7.1499 6.45039C7.24157 6.54206 7.2874 6.65872 7.2874 6.80039C7.2874 6.94206 7.24157 7.05872 7.1499 7.15039C7.05824 7.24206 6.94157 7.28789 6.7999 7.28789C6.65824 7.28789 6.54157 7.24206 6.4499 7.15039L3.9999 4.70039Z",
    fill: "#E66400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFilter);
export default __webpack_public_path__ + "static/media/remove_filter.05d0e7c8f72af3f03d8975fbd42e3d2c.svg";
export { ForwardRef as ReactComponent };